import script from "./AdminProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProducts.vue?vue&type=script&setup=true&lang=js"

import "./AdminProducts.vue?vue&type=style&index=0&id=a84f934a&scoped=true&lang=css"
import "./AdminProducts.vue?vue&type=style&index=1&id=a84f934a&scoped=true&lang=css"
import "./AdminProducts.vue?vue&type=style&index=2&id=a84f934a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a84f934a"]])

export default __exports__